import request from '@/utils/request'

/**
 * 添加账号信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function accountAdd(data) {
  return request({
    type: 'base',
    url: 'account/add',
    method: 'post',
    data
  })
}
/**
 * 删除账号
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function accountDelete(data) {
  return request({
    type: 'base',
    url: 'account/delete',
    method: 'post',
    data
  })
}
/**
 * 获取用户详情
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function accountDetailGet(data) {
  return request({
    type: 'base',
    url: 'account/detail/get',
    method: 'post',
    data
  })
}
/**
 * undefined
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function accountInfoDetailGet(data) {
  return request({
    type: 'base',
    url: 'account/info/detail/get',
    method: 'post',
    data
  })
}
/**
 * 获取自己所在体系下的所有人员
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function accountListBySelfsysGet(data) {
  return request({
    type: 'base',
    url: 'account/list/by/selfsys/get',
    method: 'post',
    data
  })
}
/**
 * 获取账号列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function accountListGet(data) {
  return request({
    type: 'base',
    url: 'account/list/get',
    method: 'post',
    data
  })
}
/**
 * 获取登录用户信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function accountLoginGet(data) {
  return request({
    type: 'base',
    url: 'account/login/get',
    method: 'post',
    data
  })
}
/**
 * 移动账号(作废)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function accountMoveUpdate(data) {
  return request({
    type: 'base',
    url: 'account/move/update',
    method: 'post',
    data
  })
}
/**
 * 修改密码
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function accountPwdUpdate(data) {
  return request({
    type: 'base',
    url: 'account/pwd/update',
    method: 'post',
    data
  })
}
/**
 * 重置账号密码
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function accountResetPwdUpdate(data) {
  return request({
    type: 'base',
    url: 'account/reset/pwd/update',
    method: 'post',
    data
  })
}
/**
 * 获取角色底下所有账户
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function accountRoleListGet(data) {
  return request({
    type: 'base',
    url: 'account/role/list/get',
    method: 'post',
    data
  })
}
/**
 * 获取非某个角色的所有账户
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function accountUnroleListGet(data) {
  return request({
    type: 'base',
    url: 'account/unrole/list/get',
    method: 'post',
    data
  })
}
/**
 * 编辑账号
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function accountUpdate(data) {
  return request({
    type: 'base',
    url: 'account/update',
    method: 'post',
    data
  })
}
/**
 * 获取人员信息列表(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthAccountDetailAllList(data) {
  return request({
    type: 'base',
    url: 'oauth/account/detail/all/list',
    method: 'post',
    data
  })
}
/**
 * 获取人员信息(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthAccountDetailGet(data) {
  return request({
    type: 'base',
    url: 'oauth/account/detail/get',
    method: 'post',
    data
  })
}
/**
 * 获取人员信息(内部使用)(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthAccountDetailInnerGet(data) {
  return request({
    type: 'base',
    url: 'oauth/account/detail/inner/get',
    method: 'post',
    data
  })
}
/**
 * 根据用户id获取用户信息(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthAccountDetailList(data) {
  return request({
    type: 'base',
    url: 'oauth/account/detail/list',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/Account.js